import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

import {
  Feature,
  FeatureNames,
  OperatingProgramProperties,
  ProgramCommands,
  ScheduleCommands,
  ScheduleProperties,
} from '@vi-iot/client';

import { InstallationFeaturesStore } from '@store';

import {
  Program,
  ScheduleService,
  TimemanagerDialogService,
} from '../../../../../../../features/timemanager/services';
import { HeatingPanelService, HEATING_PROGRAMS } from '../heating-panel.service';

@Component({
  selector: 'app-single-family-house-panel',
  templateUrl: './single-family-house-panel.component.html',
  styleUrls: ['./single-family-house-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SingleFamilyHousePanelComponent implements OnInit {
  @Input() circuitId: string;
  ngUnsubscribe$: Subject<void> = new Subject<void>();
  heatingPrograms = HEATING_PROGRAMS;
  heatingSchedule$: Observable<Feature<ScheduleProperties, ScheduleCommands>>;
  reducedCooling$: Observable<Feature<OperatingProgramProperties, ProgramCommands>>;
  normalCooling$: Observable<Feature<OperatingProgramProperties, ProgramCommands>>;
  comfortCooling$: Observable<Feature<OperatingProgramProperties, ProgramCommands>>;
  programs$: BehaviorSubject<Program[]> = new BehaviorSubject<Program[]>([]);

  constructor(
    public timemanagerDialogService: TimemanagerDialogService,
    public heatingPanelService: HeatingPanelService,
    private installationFeaturesStore: InstallationFeaturesStore,
    private scheduleService: ScheduleService
  ) {}

  ngOnInit(): void {
    this.programs$ = this.scheduleService.programs$;
    this.heatingSchedule$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.circuitHeatingSchedule(this.circuitId)
    );
    this.reducedCooling$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.circuitReducedCooling(this.circuitId)
    );
    this.normalCooling$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.circuitNormalCooling(this.circuitId)
    );
    this.comfortCooling$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.circuitComfortCooling(this.circuitId)
    );
  }
}
